import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { InteractivePlanComponent } from './interactive-plan.component';

@NgModule({
  declarations: [
    InteractivePlanComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule
  ],
  exports: [
    InteractivePlanComponent
  ]
})
export class InteractivePlanModule { }



